"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewReviewFormDialog = NewReviewFormDialog;
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _formik = require("formik");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var Yup = _interopRequireWildcard(require("yup"));
var _models = require("../../models");
var _services = require("../../services");
var _button = require("../button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function NewReviewFormDialog({
  canClose,
  report,
  onClose,
  ...props
}) {
  const {
    isSubmitting,
    values,
    touched,
    errors,
    setValues,
    setFieldValue,
    setTouched,
    handleChange,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      description: '',
      close: false
    },
    validationSchema: Yup.object().shape({
      description: Yup.string().min(10).required()
    }),
    onSubmit
  });
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  (0, _react.useEffect)(() => {
    if (props.open) {
      setValues({
        description: '',
        close: false
      });
      setTouched({
        description: false
      });
    }
  }, [props.open]);
  async function onSubmit({
    description,
    isValid,
    close
  }, {
    setSubmitting
  }) {
    setSubmitting(true);
    try {
      let updatedReport = report.clone();
      if (updatedReport instanceof _models.Report) {
        const newReview = await _services.ReportService.addReview({
          reportId: report.id,
          comment: description,
          rating: undefined
        });
        if (close) updatedReport = await _services.ReportService.updateReport(report.id, {
          status: 'CLOSED',
          isValid
        });else updatedReport.reviews.push(newReview);
      } else {
        const data = close ? {
          response: description,
          status: 'CLOSED'
        } : {
          response: description
        };
        updatedReport = await _services.RouteReportService.updateRouteReport(report.id, data);
      }
      onClose(updatedReport);
    } catch {
      enqueueSnackbar?.(t('commons.report.reviews.not_added'));
    }
    setSubmitting(false);
  }
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    disableEscapeKeyDown: isSubmitting,
    maxWidth: "sm",
    onClose: (_, reason) => reason !== 'backdropClick' && onClose(),
    sx: {
      '.MuiPaper-root': {
        borderRadius: 4
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle2.default, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: `commons.${report instanceof _models.Report ? 'report.review_dialog' : 'route_report.response_dialog'}.title`
  })), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    multiline: true,
    disabled: isSubmitting,
    error: touched.description && Boolean(errors.description),
    id: "description",
    inputProps: {
      min: 10
    },
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: `commons.${report instanceof _models.Report ? 'report.reviews' : 'route_report.response_dialog'}.tooltip`
    }),
    margin: "dense",
    name: "description",
    onChange: handleChange,
    rows: 3,
    value: values.description,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: isSubmitting,
    onClick: () => onClose(),
    size: "small",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.close"
  })), report.status === 'OPEN' && canClose && /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: isSubmitting,
    onClick: () => {
      setFieldValue('close', true);
      handleSubmit();
    },
    size: "small",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.report.review_dialog.actions.send_and_close"
  })), report.status === 'OPEN' && canClose && /*#__PURE__*/_react.default.createElement(_button.Button, {
    disabled: isSubmitting,
    onClick: () => {
      setFieldValue('close', true);
      setFieldValue('isValid', true);
      handleSubmit();
    },
    size: "small",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.report.review_dialog.actions.send_reward_and_close"
  })), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "primary",
    disabled: isSubmitting,
    size: "small",
    type: "submit",
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.send"
  })))));
}